import { Moon, Sun } from "lucide-react";
import React from "react";
import { THEMES, THEME_OPTIONS, useTheme } from "../ThemeContext";

export const ThemeSwitcher = () => {
	const { theme, setTheme } = useTheme();

	const toggleTheme = () => {
		const currentIndex = THEME_OPTIONS.indexOf(theme);
		const nextIndex = (currentIndex + 1) % THEME_OPTIONS.length;
		setTheme(THEME_OPTIONS[nextIndex]);
	};

	// Icon mapping for each theme
	const themeIcons = {
		[THEMES.LINEAR]: <Moon className="h-4 w-4" />,
		[THEMES.LINEAR_LIGHT]: <Sun className="h-4 w-4" />,
	};

	return (
		<button
			type="button"
			onClick={toggleTheme}
			className="flex items-center justify-center p-1 rounded-md text-[var(--color-text-tertiary)] hover:bg-[var(--color-bg-secondary)] hover:text-[var(--color-text-primary)] focus:outline-none focus:ring-2 focus:ring-[var(--color-accent)] focus:ring-opacity-50 transition-colors"
			aria-label="Cycle theme"
			title="Cycle theme"
		>
			{themeIcons[theme] || themeIcons[THEMES.LINEAR]}
		</button>
	);
};
